<div id="popup">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span>
            Call
        </span>
        <button [attr.guide]="'call-list-btn-1' + '__' + sanitizeUrl(url)" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <mat-dialog-content style=" MARGIN: 0PX; 
    padding: 0px;" ngStyle.lt-md="max-height: 100%;">
        <div class="padding-11">
            <div fxLayout="column" style="overflow: auto;" [formGroup]="firstFormGroup">

                <div fxHide fxShow.gt-md fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                    <mat-form-field appearance="outline" fxFlex>
                        <mat-label>Call Type</mat-label>
                        <mat-select formControlName="phoneCallType">
                            <mat-option *ngFor="let status of phoneCallType" [value]="status.value">
                                {{status.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div fxHide fxShow.lt-sm fxShow.lt-md fxShow.lt-lg fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                    <mat-form-field appearance="outline" fxFlex>
                        <mat-label>Call Type</mat-label>
                        <mat-select formControlName="phoneCallType">
                            <mat-option *ngFor="let status of phoneCallTypenew" [value]="status.value">
                                {{status.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

            </div>

            <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                <button [attr.guide]="'call-list-btn-2' + '__' + sanitizeUrl(url)" type="button" mat-raised-button (click)="close()">Cancel
                </button>

                <button [attr.guide]="'call-list-btn-3' + '__' + sanitizeUrl(url)" [disabled]="text !='Ok'" (click)="submit()" mat-raised-button>
                    {{text}}
                    <mat-icon *ngIf="text !='Ok' ">
                        <mat-spinner color="primary" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </button>
            </div>
        </div>
    </mat-dialog-content>
</div>